
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bridal-partners",
      function () {
        return require("private-next-pages/bridal-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bridal-partners"])
      });
    }
  